const formatCurrency = (
    value: number,
    fractionDigits: number = 2,
    useGrouping = true,
    withHTML = true
) => {
    const formatted = value.toLocaleString("en-GB", {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
        style: "currency",
        currency: "GBP",
        useGrouping,
    });

    if (!withHTML) {
        return formatted;
    }

    return formatted
        .replaceAll("£", "<span>£</span>")
        .replaceAll(",", "<span>,</span>")
        .replaceAll(".", "<span>.</span>");
};

export default formatCurrency;
